import BannerHeading from "./BannerHeading.vue";
import Blip from "./Blip.vue";
import Button from "./Button.vue";
import Card from "./Card.vue";
import CheckBox from "./CheckBox.vue";
import Divider from "./Divider.vue";
import Drawer from "./Drawer.vue";
import Dropdown from "./Dropdown.vue";
import DropdownLabel from "./DropdownLabel.vue";
import DropdownMultiple from "./DropdownMultiple.vue";
import DropdownSingle from "./DropdownSingle.vue";
import FieldError from "./FieldError.vue";
import FieldGroup from "./FieldGroup.vue";
import FieldHelp from "./FieldHelp.vue";
import FieldLabel from "./FieldLabel.vue";
import Image from "./Image.vue";
import ImageUpload from "./ImageUpload.vue";
import Layout from "./Layout.vue";
import LoadingButton from "./LoadingButton.vue";
import Material from "./Material.vue";
import PaymentMethod from "./PaymentMethod.vue";
import RadioButton from "./RadioButton.vue";
import RadioGroup from "./RadioGroup.vue";
import Row from "./Row.vue";
import RowEnd from "./RowEnd.vue";
import Stepper from "./Stepper.vue";
import Tabs from "./Tabs.vue";
import TagName from "./TagName.vue";
import TextField from "./TextField.vue";
import TextInput from "./TextInput.vue";
import TextInputOutline from "./TextInputOutline.vue";
import Tile from "./Tile.vue";
import Toast from "./Toast.vue";

export const Design = {
  BannerHeading,
  Blip,
  Button,
  Toast,
  Card,
  CheckBox,
  Divider,
  Drawer,
  Dropdown,
  DropdownLabel,
  DropdownMultiple,
  DropdownSingle,
  FieldError,
  FieldGroup,
  FieldLabel,
  FieldHelp,
  Image,
  ImageUpload,
  Layout,
  LoadingButton,
  Material,
  PaymentMethod,
  RadioButton,
  RadioGroup,
  Row,
  RowEnd,
  Stepper,
  Tabs,
  TagName,
  TextField,
  TextInput,
  TextInputOutline,
  Tile,
};
